import { render, staticRenderFns } from "./GovernmentWorkListItem.vue?vue&type=template&id=0c682b17&"
import script from "./GovernmentWorkListItem.vue?vue&type=script&lang=js&"
export * from "./GovernmentWorkListItem.vue?vue&type=script&lang=js&"
import style0 from "./GovernmentWorkListItem.vue?vue&type=style&index=0&id=0c682b17&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports